<script setup>
import { computed, toRefs, ref, onMounted, nextTick } from 'vue'
import { useUserStore } from '@/stores/user'
import BarcodeReader from '@/components/shared/BarcodeReader.vue'
import Quagga from 'quagga'

const brandName = import.meta.env.VITE_BRAND_NAME

const showBarcodeReader = computed(() => {
  return ['dinamica'].includes(brandName)
})

const props = defineProps({
  colValue: { type: Number, required: false, default: 1 },
  placeholder: { type: String, required: false, default: 'Search' },
  aditionalInputClass: { type: String, required: false, default: '' },
  aditionalContainerClass: { type: String, required: false, default: '' },
  aditionalMainClass: { type: String, required: false, default: '' }
})

const emit = defineEmits(['search'])

const { placeholder, aditionalMainClass } = toRefs(props)

const stringClassByRules = computed(() => {
  return `col-${props.colValue || 12} ` + props.aditionalContainerClass
})

const userStore = useUserStore()
const localSearchValue = ref(userStore.searchValue)
const modalBarcodeReader = ref(null)
const isScanning = ref(false)

// Detectar si está en un dispositivo móvil
const isMobile = ref(false)

onMounted(() => {
  isMobile.value = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)
  console.log(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
  console.log('Quagga está disponible:', Quagga)
})

const startBarcodeScanner = () => {
  if (isScanning.value) return
  isScanning.value = true
  nextTick(() => {
    modalBarcodeReader.value.showModal()
  })
}

const scannedCode = (code) => {
  localSearchValue.value = code
  userStore.updateSearch(code)
  emit('search', code)
}

// Limpiar búsqueda
function clearSearch() {
  localSearchValue.value = ''
  userStore.updateSearch('')
  emit('search', '')
}
</script>

<template>
  <div class="d-flex" :class="aditionalMainClass">
    <div :class="stringClassByRules" class="input-search">
      <slot name="beforeInput"></slot>
      <div class="position-relative">
        <input
          :class="'input-search form-control border-end-0 border ' + aditionalInputClass"
          type="search"
          v-model="localSearchValue"
          v-debounce.2000="
            (e) => {
              userStore.updateSearch(e.target.value)
              emit('search', e.target.value)
            }
          "
          @keydown.enter="
            (e) => {
              userStore.updateSearch(e.target.value)
              emit('search', e.target.value)
            }
          "
          :placeholder="placeholder"
          id="example-search-input"
        />
        <button
          class="clear-icon-search-store"
          type="button"
          @click="clearSearch"
          v-if="localSearchValue"
        >
          <font-awesome-icon icon="fa-solid fa-times" />
        </button>
      </div>
    </div>
    <BarcodeReader
      v-if="showBarcodeReader && isMobile && isScanning"
      ref="modalBarcodeReader"
      @readBarcode="scannedCode"
    />

    <!-- Botón para escanear código de barras (solo en móviles) -->
    <button
      v-if="showBarcodeReader && isMobile"
      class="btn btn-secondary ms-2"
      @click="startBarcodeScanner"
    >
      <font-awesome-icon icon="fa-solid fa-barcode" />
    </button>

    <slot name="extraElements"></slot>
  </div>
</template>

<style scoped>
/* Estilos adicionales si son necesarios */

#barcode-scanner video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover; /* Asegura que el video se ajuste al contenedor */
}
</style>
